export default [
  {
    path: '/setting/list',
    name: 'setting-list',
    component: () => import('@/views/setting/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Setting',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Setting', active: true }
      ]
    }
  },
  {
    path: '/notification',
    name: 'notification',
    component: () => import('@/views/setting/notification.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Notification',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Notification', active: true }
      ],
      permissions: ['notification_send']
    }
  },
  {
    path: '/setting/hotel-amenities',
    name: 'hotel-amenities-setting',
    component: () => import('@/views/setting/HotelAmenities.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Hotel Amenities',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Admin Setting', url: '/setting/list' },
        { title: 'Hotel Amenities', active: true }
      ],
      roles: ['admin']
    }
  }
]
